import request from '@/utils/request'
// 存取款 等金额接口集合

// 充值首页
export function rechargeIndex() {
  return request.get('/transfer/rechargeIndex')
}

// 充值开始
export function rechargeStartApi(data) {
  return request.post('/transfer/rechargeStart', data)
}

// 用户设置自己提现密码
export function setWithdrawPasswordApi(data) {
  return request.post('/v1/setWithdrawPassword', data)
}

// 验证提现密码
export function verifyWithdrawPasswordApi(data) {
  return request.post('/v1/verifyWithdrawPassword', data)
}

// 设置PIX账户
export function setPixAccountApi(data) {
  return request.post('/v1/cardBank/setPixAccount', data)
}

// 设置默认的银行账户
export function setDefaultApi(data) {
  return request.post('/v1/cardBank/setDefault', data)
}

// 提现申请
export function withdrawStartApi(data) {
  return request.post('/transfer/withdrawStart', data)
}

// 提现订单列表
export function withdrawOrderListApi(data) {
  return request.post('/transfer/withdrawOrderList', data)
}

// 提现订单详情
export function withdrawQueryOrderInfoApi(params) {
  return request.get('/transfer/withdrawQueryOrderInfo', { params })
}

// 获取用户余额 - 最新
export function userBalanceApi() {
  return request.get('/v1/userBalance')
}

// 获取充值订单状态
export function rechargeQueryOrderInfoApi(data) {
  return request.post('/transfer/rechargeQueryOrderInfo', data)
}

// 全部待领取记录
export function pendingListApi() {
  return request.get('/inviteBonus/pendingList')
}

// 从全部待领取奖励记录领取奖励
export function claimPendingApi(data) {
  return request.post('/inviteBonus/claimPending', data)
}
